module.exports = __webpack_public_path__ + "static/media/whats-included-bg.3dd6a4c8.svg";